<template>
  <div v-show="modalAlertN.showModal">
    <div class="modal-class">
      <div class="modal-center">
        <div ref="modalAlert" class="modal-size">
          <div v-show="false" class="modal-title">
            <div class="title-size">{{ modalAlertN.title }}</div>
            <font-awesome-icon icon="xmark" class="icon-file" @click="closeModal()" />
          </div>
          <div class="modal-detail">
            <div class="image-icon">
              <img
                v-show="modalAlertN.type !== 'success'"
                src="@/assets/images/icon/brake-warning-duotone.svg"
                alt=""
                class="image-confirm"
              />
              <img
                v-show="modalAlertN.type === 'success'"
                src="@/assets/images/icon/check-circle-duotone.svg"
                alt=""
                class="image-success"
              />
            </div>
            <div class="title-size">{{ modalAlertN.title }}</div>
            <div class="message" :class="modalAlertN.messageClass">{{ modalAlertN.message }}</div>
            <div v-if="modalAlertN.warning" class="message text-danger">{{ modalAlertN.warning }}</div>
          </div>
          <div v-show="!modalAlertN.confirm" class="group-footer center">
            <button v-if="!modalAlertN.notClose" type="button" class="btn btn-success" @click="closeModal()">
              <img src="@/assets/images/icon/times-circle-duotone.svg" alt="" class="image-times" />
              ปิด
            </button>
            <button v-else type="button" class="btn btn-success" @click="closeModal()">
              <img src="@/assets/images/icon/check-circle-duotoneffffff.svg" alt="" class="image-times" />
              ยืนยัน
            </button>
          </div>
          <div v-show="modalAlertN.confirm" class="group-footer">
            <button type="button" class="btn btn-success" @click="confirmModal()">
              <img src="@/assets/images/icon/check-circle-duotoneffffff.svg" alt="Confirm" />
              ยืนยัน
            </button>
            <button type="button" class="btn btn-danger" @click="closeModal()">
              <img src="@/assets/images/icon/times-circle-duotone.svg" alt="Cancel" />
              ยกเลิก
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComponentInput',
  props: ['modalAlert'],
  data() {
    return {
      modalAlertN: this.modalAlert,
      myTimeout: '',
    }
  },
  watch: {
    'modalAlert.showModal'() {
      this.modalAlertN = this.modalAlert
      document.body.style.overflow = this.modalAlert.showModal ? 'hidden' : ''
    },
  },
  created() {
    // document.addEventListener('click', this.focusoutBtn)
  },
  methods: {
    focusoutBtn(e) {
      if (this.modalAlertN.showModal && !this.modalAlertN.confirm) {
        if (this.$refs.modalAlert) {
          let target = e.target
          if (this.$refs.modalAlert !== target && !this.$refs.modalAlert.contains(target)) {
            this.closeModal()
          }
        }
      }
    },
    closeModal() {
      this.modalAlertN.showModal = false
      // clearTimeout(this.myTimeout);
      if (this.modalAlertN.msgSuccess && !this.modalAlertN.confirm) {
        this.modalAlertN.afterPressAgree()
      }
    },
    confirmModal() {
      this.modalAlertN.showModal = false
      // clearTimeout(this.myTimeout);
      if (this.modalAlertN.msgSuccess) {
        this.modalAlertN.afterPressAgree()
      } else {
        this.$emit('confirm-modal', this.modalAlertN.status)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.modal-class {
  position: fixed;
  overflow-y: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: rgba(33, 85, 163, 0.16);

  .modal-center {
    height: 85%;
    display: flex;
    justify-content: center;
    align-items: center;

    .modal-size {
      width: 100%;
      pointer-events: auto;
      margin: auto 20px;
      max-width: 758px;
      background-color: #ffffffff;
      border-radius: 15px;
      padding: 40px;
      display: flex;
      flex-direction: column;
      gap: 40px;

      .modal-title {
        display: flex;
        justify-content: space-between;

        .title-size {
          font-size: 24px;
          font-weight: 700;
          color: #0a1629;
          margin-top: 5px;
        }

        .close-size {
          padding: 13px;
          width: 44px;
          height: 44px;
          border-radius: 14px;
          background-color: #f4f9fd;
          cursor: pointer;
        }
        .icon-file {
          font-size: 25px;
          cursor: pointer;
        }
      }

      .modal-detail {
        display: flex;
        flex-direction: column;
        gap: 20px;
        .image-icon {
          text-align: center;

          .image-confirm {
            width: 104px;
            height: 74px;
          }

          .image-success {
            width: 80px;
            height: 80px;
          }
        }

        .title-size {
          font-size: 20px;
          font-weight: 600;
          color: #333;
          text-align: center;
        }

        .message {
          text-align: center;
          font-size: 18px;
          font-weight: 500;
          white-space: pre-line;
        }
      }

      .group-footer {
        text-align: center;
        display: flex;
        justify-content: space-between;
        gap: 20px;
        padding: 0;

        button {
          font-size: 18px;
          padding: 10px 20px;
        }
      }

      .center {
        justify-content: center;
      }
    }
  }
}
</style>
